import React, { useMemo } from "react";

import { palette, spacing } from "../styles";
import Block from "./Block";
import SvgIcon from "./SvgIcon";
import Touchable from "./Touchable";

type Props = {
  currentRating?: number;
  size?: number;
  padding?: number;
  width?: number;
  setRating?: (rating: number) => void;
};

const RatingScale = ({
  size = spacing.unit * 6.25,
  padding = 3,
  currentRating = 0,
  setRating,
  width,
}: Props) => {
  const rating = useMemo(() => {
    const stars: React.JSX.Element[] = [];

    for (let i = 1; i <= 5; i++) {
      const component = (
        <Touchable
          focusable={false}
          key={i}
          onPress={() => setRating?.(i)}
          pointerEvents={setRating ? "auto" : "none"}
        >
          <Block padding={padding} {...(width && { width })}>
            <SvgIcon
              color={i <= currentRating ? palette.primary.accent : palette.font.placeholder}
              name="star"
              size={size}
            />
          </Block>
        </Touchable>
      );

      stars.push(component);
    }
    return stars;
  }, [setRating, padding, currentRating, size, width]);

  return <Block row>{rating}</Block>;
};

export default React.memo(RatingScale);
